<template>
  <div class="have-teams-workspace-wrapper">
    <GridTransferToolbar v-model="searchTeamModel"
                         :teams-count="stageTeamsCount"
                         :transfer-mode.sync="isTransferMode"
                         :selected-count="selectedTransferTeams.length"
                         :can-transfer="!isCompletedTournament"
                         :loading="isLoadingStageTeams"
                         @quick-pick="quickPick"
                         @clear="clearTransferSelection"/>
    <div v-if="test_tree && test_tree.children" class="tree-container">
      <TreeView
          :dataset="displayTree"
          linkStyle="straight"
          direction="horizontal-rtl"
          :config="treeConfig"
          :dragEnabled="false"
      >
        <template v-slot:node="{ node, collapsed }">
          <div class="tournament-match-node">
            <div v-if="isFinalNode(node)" :class="['match-info', 'final-match', { 'transfer-mode': isTransferMode }]">
              <template v-if="node.teams && node.teams.length > 0">
                <div v-for="(team, index) in node.teams"
                     :key="`${node.name}-${team.name}-${index}`"
                     :title="teamTooltip(team)"
                     @click="onGridTeamClick(team, node)"
                     :class="['team', {
                         'winner champion': isTeamWinner(team, node.teams),
                         'loser': !isTeamWinner(team, node.teams),
                         'pickable': isTransferMode && isTeamTransferable(team),
                         'not-pickable': isTransferMode && !isTeamTransferable(team),
                         'picked': isTransferMode && isTeamPicked(team)
                       }]">
                  <span v-if="isTransferMode" class="pick-box">&#10003;</span>
                  <span class="team-name">{{ team.name }}</span>
                  <span class="team-score">{{ team.score }}</span>
                </div>
                <div v-for="emptySlot in Math.max(0, 2 - node.teams.length)"
                     :key="`empty-final-${node.name}-${emptySlot}`"
                     @click="openNodeModal(node)"
                     class="team loser empty-team">
                  <span class="team-name"></span>
                  <span class="team-score"></span>
                </div>
              </template>
              <template v-else>
                <div v-for="team in 2"
                     :key="`team-final-empty-${team}`"
                     @click="openNodeModal(node)"
                     class="team loser empty-team">
                  <span class="team-name"></span>
                  <span class="team-score"></span>
                </div>
              </template>
            </div>
            <div v-else-if="node.teams && node.teams.length > 0" :class="['match-info', { 'transfer-mode': isTransferMode }]">
              <div v-for="(team, index) in node.teams"
                   :key="`${node.name}-${team.name}-${index}`"
                   :title="teamTooltip(team)"
                   @click="onGridTeamClick(team, node)"
                   :class="['team', {
                       'winner': isTeamWinner(team, node.teams),
                       'loser': !isTeamWinner(team, node.teams),
                       'pickable': isTransferMode && isTeamTransferable(team),
                       'not-pickable': isTransferMode && !isTeamTransferable(team),
                       'picked': isTransferMode && isTeamPicked(team)
                     }]">
                <span v-if="isTransferMode" class="pick-box">&#10003;</span>
                <span class="team-name">{{ team.name }}</span>
                <span class="team-score">{{ team.score }}</span>
              </div>
              <div v-for="emptySlot in Math.max(0, 2 - node.teams.length)"
                   :key="`empty-${node.name}-${emptySlot}`"
                   @click="openNodeModal(node)"
                   class="team loser empty-team">
                <span class="team-name"></span>
                <span class="team-score"></span>
              </div>
            </div>
            <div v-else class="match-info" @click="openNodeModal(node)">
              <div v-for="team in 2" :key="`team-none-id-${team}`" class="team loser empty-team">
                <span class="team-name"></span>
                <span class="team-score"></span>
              </div>
            </div>
          </div>
        </template>
      </TreeView>
    </div>
    <div v-else>
      Загрузка данных турнира...
    </div>

    <b-modal v-model="isShowGridMatchModal"
             title="Результаты матча"
             size="xl"
             @hide="closeNodeModal"
             hide-footer
    >
      <OpenGridMatch v-if="selectedNode"
                     :params="{
                       nodeData: selectedNode,
                       stageId: selectedStageId,
                       upperGridTeamCount: null,
                       lowerGridTeamCount: null,
                       onScoreUpdated:handleScoreUpdateChange,
                       onRollback:handleRollbackGroupTeam
                     }"
                     @handleCloseModal="closeNodeModal"
                     @getGrids="getGrids"
      />
    </b-modal>

    <GridTransferDock :teams="selectedTransferTeams"
                      @remove="toggleTransferTeam"
                      @clear="clearTransferSelection"
                      @submit="isShowTransferModal = true"/>

    <Modals v-model="isShowTransferModal"
            name="TransferTeamsFromGrid"
            title="Перенос команд в следующий этап"
            size="lg"
            :params="{ teams: selectedTransferTeams, currentStageId: selectedStageId }"
            @submit="handleTransferSubmitted"/>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import api from "@/api/api";
import OpenGridMatch from "@/components/modals/OpenGridMatch.vue";
import Modals from "@/components/modals/index.vue";
import GridTransferDock from "@/components/Tournament/MLBB/components/GridTransferDock.vue";
import GridTransferToolbar from "@/components/Tournament/MLBB/components/GridTransferToolbar.vue";
import {filterTree} from "@/common/filters";
import {isTeamWinner} from "@/common/isTeamWinner";
import {connectToWs, onMessage, subscribe, unsubscribe} from "@/services/websocket";
import {AuthAdapterMixin} from "@/mixins/Auth/AuthAdapterMixin";
import {GridTransferMixin} from "@/mixins/Tournament/GridTransferMixin";

export default {
  name: "HaveTeamsWorkspace",
  mixins: [AuthAdapterMixin, GridTransferMixin],
  components: {
    OpenGridMatch,
    Modals,
    GridTransferDock,
    GridTransferToolbar
  },
  computed: {
    ...mapState('moduleNewTournament', ['selectedStageId', 'selectedRoundId', 'groupsWithTeamsByMLBB', 'tournament', 'stageTeamsCount']),
    ...mapGetters('moduleNewTournament', ['selectedGroup', 'selectedStage', 'isCompletedTournament']),
    ...mapGetters('moduleModal', ['getShow', 'getOption', 'getIdModalForDelete']),
    ...mapActions('moduleModal', ['openModal', 'closeModal', 'optionName', 'cleanOption']),
    displayTree() {
      if (!this.searchTeamModel) {
        return this.test_tree
      }
      return {
        children: filterTree(this.test_tree.children, this.searchTeamModel)
      }
    },
    // для GridTransferMixin: обходим сетку при быстром выборе команд
    transferTreeRoots() {
      return [this.test_tree?.children]
    }
  },
  data() {
    return {
      ws: null,
      tournamentChannel: null,
      wsUnsubscribe: null,
      isScoreUpdated: false,
      isShowGridMatchModal: false,
      selectedNode: null,
      cloneGroups: [],
      apiGridData: null,
      isLoadingSaveTransferredTeams: false,
      searchTeamModel: '',
      selectedTeamForGrid: null,
      test_tree: {},
      _getGridsTimer: null,
      treeConfig: {
        nodeWidth: 90,
        linkSeparation: 100,
        nodeHeight: 80,
        levelHeight: 130,
        buildMode: 'children',
      }
    }
  },
  methods: {
    isTeamWinner,
    ...mapMutations('moduleNewTournament', ['setFirstLevelData']),
    subscribeToTournamentChannel() {
      const tournamentId = this.tournament?.id
      if (!tournamentId || this.tournamentChannel) return
      this.tournamentChannel = `tournaments.${tournamentId}`
      subscribe(this.tournamentChannel, localStorage.getItem('token'))
    },
    openNodeModal(node) {
      // В режиме переноса клик по сетке используется для выбора команд
      if (this.isTransferMode) return
      this.selectedNode = node;
      this.isShowGridMatchModal = true;
    },
    handleWebSocketMessage(message) {
      console.log("MESSAGE", message)
      switch (message.event) {
        case 'groupResult.fields.changed':
          this.handleGroupResultChanged(message.data)
          break;
        case 'tournament.group.team.new':
          this.handleNewTeam(message.data)
          break
        default:
          console.log('Неизвестное событие:', message.event)

      }
    },
    async handleGroupResultChanged(data) {
      console.log("data", data)
      await this.getGrids()

      this.$bvToast.toast('Результаты матча обновлены', {
        title: 'Обновление',
        variant: 'info',
        solid: true,
        autoHideDelay: 2000
      })
    },
    async handleNewTeam() {
      await this.getGrids()
      this.$bvToast.toast('Добавлена новая команда в турнир', {
        title: 'Обновление',
        variant: 'success',
        solid: true,
        autoHideDelay: 2000
      })
    },
    async handleRollbackGroupTeam(groupTeamsId) {
      try {
        const res = await api.tournament.rollback(groupTeamsId)

        if (res.status === 204) {
          this.$bvToast.toast('Откат успешно выполнен', {
            title: 'Успех',
            variant: 'success',
            solid: true,
            autoHideDelay: 2000
          })

          // Закрываем модалку
          this.closeNodeModal()

          // Обновляем данные турнира
          await this.getGrids()
        }
      } catch (e) {
        console.error('Ошибка при откате:', e)
        this.$bvToast.toast(e.response?.data?.message || 'Ошибка при откате', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      }
    },
    closeNodeModal() {
      this.isShowGridMatchModal = false;
      this.selectedNode = null;
    },

    isFinalNode(node) {
      return node && (
          node.next_group_id === null ||
          node.next_group_id === undefined ||
          node.next_round_id === null
      );
    },
    async handleScoreUpdateChange(value) {
      if (value === true) {
        await this.getGrids();
      }
    },

    findNodeByKey(nodes, key) {
      for (const node of nodes) {
        if (node._key === key) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodeByKey(node.children, key);
          if (found) return found;
        }
      }
      return null;
    },

    getGrids() {
      clearTimeout(this._getGridsTimer)
      return new Promise((resolve) => {
        this._getGridsTimer = setTimeout(async () => {
          try {
            const res = await api.grid.getGrid(this.selectedStageId);
            const newGridData = res.data.data.grids[0];
            if (!newGridData) {
              console.error('No grid data received from API');
              this.showError('Данные турнира не найдены');
              resolve();
              return;
            }

            if (!newGridData.matches || newGridData.matches.length === 0) {
              console.error('No matches in grid data');
              this.showError('Матчи не найдены');
              resolve();
              return;
            }

            if (!newGridData.teams || newGridData.teams.length === 0) {
              console.warn('No teams in grid data');
            }

            this.apiGridData = newGridData;

            this.test_func();
          } catch (error) {
            console.error('Error loading grid data:', error);
            this.showError('Ошибка при загрузке данных турнира');
          }
          resolve();
        }, 300)
      })
    },

    showError(message) {
      this.$bvToast.toast(message, {
        title: 'Ошибка',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000
      });
    },

    test_func() {
      if (!this.apiGridData) {
        console.warn('No API data available for tree building');
        return;
      }

      const matches = this.apiGridData.matches || [];
      const teams = this.apiGridData.teams || [];

      if (matches.length === 0) {
        console.warn('No matches to process');
        this.$set(this, 'test_tree', {children: []});
        return;
      }

      const treeData = {
        children: this.buildBracketRecursive(matches, teams)
      };

      this.$set(this, 'test_tree', treeData);
      this.$forceUpdate();
    },

    buildBracketRecursive(matches, teams = []) {
      const byId = new Map(matches.map(m => [m.id, m]));
      const childrenByParent = new Map();
      const teamsMap = new Map(teams.map(t => [t.id, t.name]));
      const contactsById = new Map(teams.map(t => [t.id, t.contacts || []]));


      const groupToRoundMap = new Map();
      if (this.apiGridData && this.apiGridData.groups) {
        this.apiGridData.groups.forEach(group => {
          groupToRoundMap.set(group.id, group.round_id);
        });
      }

      const roundNamesMap = new Map();
      if (this.apiGridData && this.apiGridData.rounds) {
        this.apiGridData.rounds.forEach(round => {
          roundNamesMap.set(round.id, round.name);
        });
      }

      for (const match of matches) {
        const p = match.next_group_id;
        if (p == null) continue;
        if (!childrenByParent.has(p)) childrenByParent.set(p, []);
        childrenByParent.get(p).push(match.id);
      }

      const roots = matches.filter(m => m.next_group_id == null).map(m => m.id);

      function buildNode(id, visiting = new Set()) {
        if (visiting.has(id)) {
          return {name: String(id), children: [], next_round_id: null};
        }
        visiting.add(id);

        const childIds = childrenByParent.get(id) || [];
        const children = childIds.map(cid => buildNode(cid, new Set(visiting)));
        const match = byId.get(id);
        const nextRoundId = match?.next_group_id ? groupToRoundMap.get(match.next_group_id) : null;
        const nextRoundName = nextRoundId ? roundNamesMap.get(nextRoundId) : null;

        if (match && match.teams && match.teams.length > 0) {


          const limitedTeams = match.teams
              .slice(0, 2)
              .map((team, idx) => ({...team, originalIndex: idx}))
          // .sort((a, b) => {
          //   const scoreA = a.result_fields?.winner_matches_count || 0;
          //   const scoreB = b.result_fields?.winner_matches_count || 0;
          //   return scoreB - scoreA;
          // });

          const processedTeams = limitedTeams.map((team, index) => {
            const teamName = teamsMap.get(team.id) || `Team ${team.id}`;
            const score = team.result_fields?.winner_matches_count || 0;

            let isWinner = team.result_fields?.is_winner === 1
            if (!isWinner && index === 0 && limitedTeams.length > 1) {
              const nextScore = limitedTeams[1]?.result_fields?.winner_matches_count || 0;
              if (score > nextScore) {
                isWinner = true;
              }
            }


            return {
              name: teamName,
              score: score,
              isWinner: team.result_fields.is_winner === 1,
              id: team.id,
              group_result_id: team.group_result_id,
              contacts: contactsById.get(team.id) || []
            };
          });


          return {
            name: `Match ${id}`,
            _key: `match-${id}`,
            children: children.length ? children : [],
            next_round_id: nextRoundId,
            next_round_name: nextRoundName,
            current_round_id: match.round_id,
            group_id: match.group_id,
            ...(match || {}),
            teams: processedTeams,
            originalTeams: match.teams
          };
        }


        return {
          name: String(id),
          _key: `match-${id}`,
          children: children.length ? children : [],
          next_round_id: nextRoundId,
          next_round_name: nextRoundName,
          current_round_id: match?.round_id,
          group_id: match?.group_id,
          ...(match || {}),
        };
      }

      const result = roots.map(rid => buildNode(rid));
      return result;
    },
  },
  watch: {
    groupsWithTeamsByMLBB: {
      deep: true,
      immediate: true,
      handler() {
        this.cloneGroups = JSON.parse(JSON.stringify(this.groupsWithTeamsByMLBB || []))
      }
    },
    'tournament.id': {
      immediate: true,
      handler() {
        this.subscribeToTournamentChannel()
      }
    },
  },
  mounted() {
    // Сначала подключаемся к WebSocket
    this.ws = connectToWs()

    // Затем устанавливаем обработчик сообщений
    this.wsUnsubscribe = onMessage((data) => this.handleWebSocketMessage(data))

    this.subscribeToTournamentChannel()

    // команды этапа грузятся лениво — только при входе в режим переноса
    this.getGrids()
  },
  beforeDestroy() {
    clearTimeout(this._getGridsTimer)
    if (this.tournamentChannel) {
      unsubscribe(this.tournamentChannel)
      this.tournamentChannel = null
    }
    if (typeof this.wsUnsubscribe === 'function') {
      this.wsUnsubscribe()
      this.wsUnsubscribe = null
    }
  }
}
</script>

<style scoped lang="scss">
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.have-teams-workspace-wrapper {
  .card-wrapper {
    background: white;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .group-cards {
    & > *:not(:last-child) {
      margin-bottom: 20px;
    }
  }

}

.tournament-match-node {
  min-width: 120px;
  max-width: 120px;
  font-size: 10px;
  padding: 6px;
}

::v-deep .tree-view .node-container {
  &:has(.final-match) {
    &::after {
      display: none !important; // скрывает линии после финала
    }
  }
}

.final-match {
  position: relative;
  // стили что убрать лишний блок
  &::after {
    content: '';
    position: absolute;
    right: -200px;
    top: 0;
    width: 200px;
    height: 100%;
    background: #f8f9fa;
    z-index: 10;
  }
}


.match-info {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}

.team {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  min-height: 28px;
  transition: all 0.3s ease;

  &.loser {
    background: #e5e5e5 !important;
    color: #7d7d8d !important;
  }

  &.winner {
    background: #0427c4 !important;
    font-weight: bold;
    color: white !important;
  }

  &.winner.champion {
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%) !important;
    color: #000 !important;
    font-weight: bold;
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
    border: 2px solid #FFD700 !important;
  }
}

.match-info.transfer-mode {
  cursor: default;
}

.pick-box {
  flex: 0 0 auto;
  width: 13px;
  height: 13px;
  margin-right: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1.5px solid rgba(125, 125, 141, .6);
  border-radius: 4px;
  opacity: .45;
  font-size: 9px;
  line-height: 1;
  // сама галочка прячется, пока команда не выбрана
  color: transparent;
  transition: .15s;
}

.team {
  &.pickable {
    cursor: pointer;

    &:hover {
      filter: brightness(1.06);

      .pick-box {
        opacity: 1;
        border-color: #7366ff;
      }
    }
  }

  &.not-pickable {
    cursor: not-allowed;
    opacity: .55;
  }

  &.picked {
    box-shadow: inset 0 0 0 2px #7366ff;

    .pick-box {
      opacity: 1;
      background: #7366ff;
      border-color: #7366ff;
      color: white;
    }
  }
}

.team-name {
  font-weight: 500;
  font-size: 11px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-score {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
}

.match-title {
  text-align: center;
  font-weight: bold;
}

.tree-container {
  overflow: visible !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  padding: 20px;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 1px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 1px;
  }
}

::v-deep .tree-view {
  min-height: 600px;
}

</style>